const styles = {
  editImageBtn: {
    position: "absolute",
    right: "5%",
    bottom: "10%",
  },
};

export default styles;
